import unsignedFetch from '../util/unsignedFetch';

export default function* getOfflineLicenseStatus(body) {
  const URL = `${__API_BASE__}/open/offline-license/status`;

  return yield unsignedFetch('getOfflineLicenseStatus', URL, 'POST', body);
}
